import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "04d5c438-e39d-4eb6-a91b-554013fd0bf3", content: "∞" },
  { id: "8530eb0c-0183-4c9b-89f0-d2bc7819a1d4", content: "+ ∞" },
  { id: "ceac68ea-fbbd-4bfb-b7a9-b7f787478f47", content: "0" },
  { id: "b97cb065-4217-4aeb-9b5d-3c6489c2b67a", content: "1" },
  { id: "37bdf426-b9bb-4294-b2df-43742cc68630", content: "-1" },
  { id: "6ccd5608-8802-4843-965e-736dfb8db30d", content: "∞" },
  { id: "50b32cf4-5f07-4531-9009-cfe1e42c80d8", content: "∞" },
  { id: "06ec787a-7a4e-46c0-a163-c510837b136e", content: "-j" },
  { id: "fe45df3b-7cc6-47d8-9122-262bb134b05f", content: "(4j-3)/5" },
  { id: "27f8529b-bd4b-4454-ba8e-48db7e83f931", content: "∞" },
  { id: "fa78e459-ac0d-4e8e-b65f-ea184451f71f", content: "3" },
  { id: "78eb6a13-86c5-428f-ab50-fa1ec0af7f61", content: "3" },
  { id: "19a293b9-3ede-4ce7-b6f9-6c356f16324f", content: "-1/2" },
  { id: "014a2475-ee4f-441b-88d9-ebb561212be9", content: "3" },
];

export const task: Task = {
  id: "bc1d4528-eedb-4fb4-a9d6-142999661abd",
  solutionType: "custom010700",
  type: "custom010700",
  options: {
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "custom010700",
  data: ["∞", "+ ∞", "0", "1", "-1", "∞", "∞", "-j", "(4j-3)/5", "∞", "3", "3", "-1/2", "3"],
};
